import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import React from "react";

export const getAppointmentCount = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getDBWithInit } = await import("~/lib/db");
    const { appointments } = await import("~/../drizzle/schema");
    const { count } = await import("drizzle-orm");

    const [result] = await (
      await getDBWithInit()
    )
      .select({ count: count() })
      .from(appointments);

    return result.count;
  },
);

export const Route = createFileRoute("/embed/number-of-appointments/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ["appointmentCount"],
      queryFn: () => getAppointmentCount(),
    });
    return {};
  },
  component: AppointmentCountPage,
});

function AppointmentCountPage() {
  const { data: appointmentCount } = useQuery({
    queryKey: ["appointmentCount"],
    queryFn: () => getAppointmentCount(),
  });

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="font-heading text-[min(40vw,40vh)] tabular-nums">
        {appointmentCount}
      </div>
    </div>
  );
}
